import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Button, Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
interface LicenseModalTabThreeProps {
  licenseDetailsAll: any; // Replace `any[]` with the specific type of the array elements
}

const LicenseModalTabThree: React.FC<LicenseModalTabThreeProps> = ({ licenseDetailsAll }) => {
  console.log(licenseDetailsAll)
    const rows = [
        {
          no: 1,
          feature: "30 Days Recording",
          licenseType: "Time Limited",
          quantity: 1,
          numberOfKeys: 1,
        },
      ];
  return (
    <div>

<TableContainer component={Paper} sx={{ backgroundColor: '#03171f', color: '#fff' ,border: "1px solid #313838"}}>
      <Table>
        <TableHead>
          <TableRow style={{ borderBottom: "2px solid #313838" }}>
            <TableCell sx={{ color: '#fff' }}>No.</TableCell>
            <TableCell sx={{ color: '#fff' }}>Feature</TableCell>
            <TableCell sx={{ color: '#fff' }}>License Type</TableCell>
            <TableCell sx={{ color: '#fff' }}>Quantity</TableCell>
            {/* <TableCell sx={{ color: '#fff' }}>Number of keys / users</TableCell>      */}
          </TableRow>
        </TableHead>
        <TableBody>
          {[licenseDetailsAll]?.map((row:any, index :any) => (
            <TableRow key={index}>
              <TableCell sx={{ color: '#fff' }}>{index+1}</TableCell>
              <TableCell sx={{ color: '#fff' }}>{row.license?.data?.name}</TableCell>
              <TableCell sx={{ color: '#fff' }}>{row.license?.data?.licenseType} Year{row.license?.data?.licenseType>1 ? "s" : ""}</TableCell>
              <TableCell sx={{ color: '#fff' }}>{row.license?.data?.quantity}</TableCell>
              {/* <TableCell sx={{ color: '#fff' }}>{row.license.data.name}</TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    </div>
  )
}

export default LicenseModalTabThree